/**
 * Schema of CargaDestinatario
 * @author Simpli CLI generator
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {$, phone} from 'simpli-web-sdk'
import CargaDestinatario from '@/model/resource/CargaDestinatario'
import RenderLabelValue from '@/components/render/RenderLabelValue.vue'
import * as Helper from '@/helpers'

export default (model: CargaDestinatario): Schema => ({
  nome: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('nome'),
          value: model.nome || $.t('app.notInformed'),
        },
      },
    ],
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  cpfCnpj: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('cpfCnpj'),
          value: Helper.formatCensoredDocument(model.cpfCnpj) || $.t('app.maskForExportDocument'),
        },
      },
    ],
    input: InputType.CPF_OR_CNPJ,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  telefone: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('telefone'),
          value: Helper.formatCensoredPhone(model.telefone) || $.t('app.notInformed'),
        },
      },
    ],
    input: InputType.PHONE,
    meta: {
      required: false,
    },
  },

  email: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('email'),
          value: model.email || $.t('app.notInformed'),
        },
      },
    ],
    input: InputType.EMAIL,
  },

  endereco: {
    content: [
      {
        component: RenderLabelValue,
        props: {
          label: model.translateColumn('endereco'),
          value: model.endereco && model.endereco.toString() || $.t('app.notInformed'),
        },
      },
    ],
    input: InputType.SELECT,
  },

})
